import {
    get,
    post
} from '../utils/request';

/**
 * 裁判员注册
 */
export const addReferee = params => post('/referee/add',params);

/** 
 * 裁判员列表
*/
export const refereeList = params => get('/referee/list',params);

/**
 * 裁判员详情
 * @param {id}
 */
export const refereeDetails = params => get('/referee/detail',params);

/**
 * 裁判员修改
 */
export const updateReferee = params => post('/referee/update',params);

/**
 * 裁判员审核
 * @param {ids} 裁判员id，批量审核用,间隔
 * @param {reason} 驳回原因
 * @param {state} 状态(4驳回5通过)
 */
export const societyAuditReferee = params => post('/referee/societyAudit',params);

/**
 * 裁判统计列表
 * @param {refereeRank} 裁判员等级(国际级、国家级、荣誉级、一级、二级)
 */
export const getRefereeCountList = params => get('/statistics/getRefereeCountList',params);
/**
 * 裁判员删除
 * @param {ids} 裁判员ID(id,id,id)
 */
export const deleteJudge = params => post('/referee/delete',params);